import React from 'react';
import Icon from '../../../components/AppIcon';

const AIInsightCard = ({ 
  title, 
  score, 
  status, 
  description, 
  icon,
  maxScore = 100 
}) => {
  const getScoreColor = (score, maxScore) => {
    const percentage = (score / maxScore) * 100;
    if (percentage >= 80) return 'text-success';
    if (percentage >= 60) return 'text-warning';
    return 'text-error';
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'positive':
        return 'TrendingUp';
      case 'neutral':
        return 'Minus';
      case 'negative':
        return 'TrendingDown';
      default:
        return 'Activity';
    }
  };

  return (
    <div className="bg-card rounded-lg p-4 border border-border transition-smooth hover:border-primary/50">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            {icon && (
              <div className="flex items-center justify-center w-8 h-8 rounded-md bg-primary/10">
                <Icon name={icon} size={16} color="var(--color-primary)" />
              </div>
            )}
            <h5 className="text-sm font-medium text-foreground font-caption">
              {title}
            </h5>
          </div>
          <div className="flex items-baseline gap-2">
            <span className={`text-2xl font-semibold font-data ${getScoreColor(score, maxScore)}`}>
              {score}
            </span>
            {maxScore && (
              <span className="text-sm text-muted-foreground font-data">
                / {maxScore}
              </span>
            )}
          </div>
        </div>
        {status && (
          <Icon 
            name={getStatusIcon(status)} 
            size={20} 
            className={
              status === 'positive' ? 'text-success' :
              status === 'negative'? 'text-error' : 'text-muted-foreground'
            }
          />
        )}
      </div>
      {description && (
        <p className="text-xs text-muted-foreground font-caption line-clamp-2">
          {description}
        </p>
      )}
    </div>
  );
};

export default AIInsightCard;